import {css} from "@emotion/react";


export const plotContent = css`
    padding: 32px 48px 16px 48px;
    width: 100%;
    position: relative;
`;